import { Outlet, createRootRoute, createRoute, createRouter } from '@tanstack/react-router'
import { createAuthRoutes } from '@jmvilaca-corp/auth-ui'
import CalendarPage from './CalendarPage'
import CalendarsPage from './CalendarsPage'

// Connexion, profil et administration des utilisateurs viennent de
// @jmvilaca-corp/auth-ui ; seules les routes metier sont declarees ici.
const rootRoute = createRootRoute({ component: Outlet })

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: CalendarPage,
})

const calendarsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/calendars',
  component: CalendarsPage,
})

export const routeTree = rootRoute.addChildren([indexRoute, calendarsRoute, ...createAuthRoutes(rootRoute)])

export const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
